import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useBlockUser } from '../../../hooks/useBlockUser';
import { setBlockUserModal } from '../../../reduxToolkit/slices/adminSlice';
import { useTranslation } from 'next-i18next';
import { reportMessage } from '../../../services/services';
import { useSelector, useDispatch } from '../../../reduxToolkit/typedRedux';

export interface BlockUserButtonProps {
  userId: string;
  meetingId?: string;
  boothId?: string;
  messageId?: string;
  element: React.ReactNode;
}

export const BlockUserButton = ({ userId, meetingId, boothId, messageId, element }: BlockUserButtonProps) => {
  const event = useSelector((state) => state.common.event);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { fetchIsUserBlocked, blockUser } = useBlockUser();

  const [isUserBlocked, setIsUserBlocked] = useState(false);

  async function handleBlockUser() {
    /**
     * We manually block the user and report the message to ensure the user is listed in the report overview.
     */
    const blockedUser = await blockUser(userId, boothId);
    try {
      await reportMessage({ userid: userId, messageid: messageId, reason: 'Manual admin block', event: event?._id });
    } catch (err) {
      console.error(err);
    }

    if (!!blockedUser) {
      toast.success(t('chat:guest-blocked'));
    }
  }

  async function fetchAndSetIsUserBlocked() {
    const isUserBlocked = await fetchIsUserBlocked(userId);
    setIsUserBlocked(isUserBlocked.data);
  }

  useEffect(() => {
    fetchAndSetIsUserBlocked();
  }, [userId, meetingId]);

  if (isUserBlocked) return null;

  return <div onClick={() => dispatch(setBlockUserModal({ onConfirm: () => handleBlockUser() }))}>{element}</div>;
};
